<template>
  <div>
    <!-- IF AUTHENTICATED -->
    <div v-if="auth.status" class="uk-text-center uk-flex-item-1">
      Authenticated as {{ auth.user }}
      <tm-button
        class="uk-button-danger uk-margin-left"
        icon="sign-out"
        title="Sign Out"
        @click="logout">
      </tm-button>
    </div>
    <!-- IF GUEST -->
    <validator name="validation">
      <form v-if="!auth.status"
        class="uk-form uk-flex uk-flex-middle uk-flex-space-between"
        @submit.prevent="login(username, password) | validate">
        <div class="uk-grid uk-grid-small uk-flex-item-1" data-uk-grid-margin>
          <div class="uk-width-large-1-3 uk-width-medium-1-1">
            <input
              autofocus
              class="uk-width-1-1 uk-form-small"
              :class="{'uk-form-danger': validateField('username')}"
              type="text"
              placeholder="Username"
              v-model="username"
              v-validate:username="['required']">
          </div>
          <div class="uk-width-large-1-3 uk-width-medium-1-1">
            <input
              class="uk-width-1-1 uk-form-small"
              :class="{'uk-form-danger': validateField('password')}"
              type="password"
              placeholder="Password"
              v-model="password"
              v-validate:password="['required']">
          </div>
          <div class="uk-width-large-1-3 uk-width-medium-1-1 uk-flex uk-flex-middle">
            <tm-button
              class="uk-align-center"
              type="submit"
              style="primary"
              icon="sign-in"
              title="Sign In">
            </tm-button>
          </div>
        </div>
      </form>
    </validator>
    <div v-if="auth.message"
      class="uk-text-center uk-margin-top"
      v-text="auth.message">
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'
import { login, logout } from '../../vuex/actions/authentication'

export default {
  data: () => ({
    username: '',
    password: ''
  }),
  vuex: {
    getters: {
      auth: state => state.products.authentication
    },
    actions: {
      login,
      logout
    }
  },
  watch: {
    'auth.show': function () {
      if (this.auth.show === false) {
        this.$resetValidation()
      }
    }
  },
  filters: {
    validate: function (cb) {
      return () => this.$validation.valid
        ? cb()
        : this.$validate(true)
    }
  },
  methods: {
    validateField: function (field) {
      return get(this.$validation, `${field}.touched`) &&
             get(this.$validation, `${field}.invalid`)
    }
  }
}
</script>



/** WEBPACK FOOTER **
 ** Authentication.vue?36d795f1
 **/